export const firebaseConfig = {
    apiKey: "AIzaSyCklqr0S4XQ-l0mejn56sW3O1ZHP04IfpY",
    authDomain: "date-keeper-696df.firebaseapp.com",
    projectId: "date-keeper-696df"
};
